import { useSelector } from 'react-redux';

import {
  makeGetDictionariesProfKindsSelectOptions,
  makeGetDictionariesSupervisionTypesExtendedSelectOptions,
} from 'CorePackage/DictionariesModule/selectors/dictionariesSelectors';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { makeGetCatalogPmConditionsSelectOptions } from 'CorePackage/CatalogsModule/selectors/catalogsSelectors';
import { createTypedUseFormValue } from 'hooks/useTypedFormField';
import { ICreatePreventionForm } from 'PreventionPackage/MainModule/interfaces/ICreatePreventionForm';

import { useCreatePreventionModalFieldsReset } from './useCreatePreventionModalFieldsReset';
import { useCreatePreventionModalOptionsFetch } from './useCreatePreventionModalOptionsFetch';

const useFieldValue = createTypedUseFormValue<ICreatePreventionForm>();

export const useCreatePreventionModal = () => {
  const knoOrganizationPm = useFieldValue('knoOrganizationPm');
  const federalLaw = useFieldValue('federalLaw');
  const supervision = useFieldValue('supervisionTypePm');
  const profKind = useFieldValue('profKind');

  const knoOrgId = knoOrganizationPm?.value?.dictVersionId;
  const federalLawId = federalLaw?.value?.dictVersionId;
  const supervisionId = supervision?.value?.dictVersionId;
  const profKindId = profKind?.value?.dictVersionId;

  useCreatePreventionModalOptionsFetch(knoOrgId, federalLawId, supervisionId, profKindId);

  useCreatePreventionModalFieldsReset();

  const supervisionSelectOptions = useSelector((state: IRootState) =>
    makeGetDictionariesSupervisionTypesExtendedSelectOptions()(
      state,
      knoOrgId ? [knoOrgId] : [],
      false,
      false,
      federalLawId ? [federalLawId] : undefined,
    ),
  );
  const profKindSelectOptions = useSelector((state: IRootState) =>
    makeGetDictionariesProfKindsSelectOptions()(state, {
      knoVersionId: knoOrgId,
      supervisionVersionId: supervisionId,
    }),
  );

  const reasonTypesSelectOptions = useSelector((state: IRootState) =>
    makeGetCatalogPmConditionsSelectOptions()(state, knoOrgId, supervisionId, true, profKindId, federalLawId),
  );

  return {
    supervisionSelectOptions,
    profKindSelectOptions,
    reasonTypesSelectOptions,
  };
};
